import { memo } from 'react';
import { useEditMode } from '../../focus/useIsEditMode';
import { AddOptionButton } from '../AddOptionButton';
import { EditableQuestion } from '../EditableQuestion';
import { SortableContainer } from '../SortableContainer';
import { EditableOrderItem } from './EditableOrderItem';
import { OrderShuffleNotice } from './OrderShuffleNotice';
import { MAX_ORDER_ITEMS, MIN_ORDER_ITEMS, type useOrderItems } from './useOrderItems';

/**
 * 순서 맞추기 보기 목록.
 *
 * 저자는 **정답 순서대로** 입력하고, 배열 순서가 그대로 정답이 된다.
 * 드래그로 재정렬하면 정답도 함께 바뀐다 — 별도의 정답 지정 UI 가 없는 이유다.
 */
export const EditableOrder = memo((props: ReturnType<typeof useOrderItems>) => {
  const {
    items,
    handleRemove,
    handleMove,
    handleAdd
  } = props;
  const {
    isEditMode
  } = useEditMode();
  return <div className="flex flex-col gap-xs pb-xs" onClick={e => e.stopPropagation()}>
      <EditableQuestion />

      {isEditMode && <OrderShuffleNotice />}

      <SortableContainer as="ol" items={items.map(item => item.id)} onDragEnd={handleMove}>
        {items.map((item, itemIndex) => <EditableOrderItem key={item.id} id={item.id} itemIndex={itemIndex} isEditMode={isEditMode} onRemove={items.length > MIN_ORDER_ITEMS && isEditMode ? () => handleRemove(itemIndex) : undefined} />)}
      </SortableContainer>

      {items.length < MAX_ORDER_ITEMS && isEditMode && <div className="pt-xs">
          <AddOptionButton onClick={e => {
        e.stopPropagation();
        handleAdd();
      }} />
        </div>}
    </div>;
});